import React, { useState } from 'react';
import SubHeader from '../general/SubHeader';

const Contact = ({ setResponse }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://api.siddhabhairabistore.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setResponse({
          message: 'Thank you for getting in touch! We will respond you soon.',
          status: 'success'
        });
        setFormData({
              name: '',
    phone: '',
    email: '',
    message: ''
        })
        setTimeout(() => setResponse(''), 3000);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      setResponse({
        message: 'Error submitting form. Please try again later.',
        status: 'error'
      });
      setTimeout(() => setResponse(''), 3000);
    }
  };

  return (
    <>
      <SubHeader message="Contact Us" />

      <section className='my-5'>
        <div className='container'>
          <div className='row text-center'>
            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <i className="fa-solid fa-envelope fs-2"></i>
              <p className='banner-text fs-5 my-0'>Email Us</p>
              <p>siddhabhairabi@gmail.com</p>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <i className="fa-solid fa-phone fs-2"></i>
              <p className='banner-text fs-5 my-0'>Make A Call</p>
              <p>+ 993 888 8882</p>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <i className="fa-solid fa-location-dot fs-2"></i>
              <p className='banner-text fs-5 my-0'>Office Address</p>
              <p>Sankarpur Street, Berhampur,<br />Ganjam, Odisha, 760006</p>
            </div>
          </div>
{/* row ends */}

                    <p className='sec-heading text-center'>Get In Touch: Fill the Form Below</p>

                            <form class="row g-2 bg-white py-4 col-lg-10 mx-auto" onSubmit={handleSubmit}>
                                <div class="my-2 col-12">
                                    <input type="text" class="product-control" value={formData.name} name='name' onChange={handleChange} placeholder='Your Name' required />
                                </div>
                                <div class="my-2 col-md-6">
                                    <input type="tel" class="product-control" value={formData.phone} name='phone' onChange={handleChange} placeholder='Your Phone' maxLength={10} required />
                                </div>
                                <div class="my-2 col-md-6">
                                    <input type="email" class="product-control" value={formData.email} name='email' onChange={handleChange} placeholder='Your Email' required />
                                </div>
                                <div className='my-2 col-12'>
                                    <textarea type="text" className="product-control" value={formData.message} name='message' onChange={handleChange} placeholder='Message' style={{ height: '10em' }}></textarea>
                                </div>

                                <div class="col-12">
                                    <button type="submit" class="banner2-btn">Send Message</button>
                                </div>
                            </form>
        </div>
      </section>

      <section className='my-5'>
        <div className='container'>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.1739283978677!2d84.77404677508265!3d19.3182575819368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d501cf958dac5%3A0xd21a996d4134d66e!2sSankarpur%20St%2C%20Triveni%20Nagar%2C%20Brahmapur%2C%20Odisha%20760002!5e0!3m2!1sen!2sin!4v1750075346131!5m2!1sen!2sin"
            className='w-100'
            height="550"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;
